import { ProviderOption } from "../../data-model/providerOptionModel";
import { OrganizationType } from "../../enums/organizationTypes";
import { FirestoreService } from "../firebase/firestoreService";
import { FirestoreCollectionReference } from "../firebase/references";

export class ProviderOptionsService {
  static async getAllProviderOptions(
    facilityId: string = OrganizationType.NYCBS_PHARMA,
  ): Promise<ProviderOption[]> {
    const path = FirestoreCollectionReference.pharmaProviderOptions(facilityId);
    return await FirestoreService.getAllDocuments<ProviderOption>(path);
  }

  static async createProviderOption(
    data: Omit<ProviderOption, "id">,
    facilityId: string = OrganizationType.NYCBS_PHARMA,
  ): Promise<void> {
    const path = FirestoreCollectionReference.pharmaProviderOptions(facilityId);
    await FirestoreService.setDocument(path, data.uid, {
      ...data,
      id: data.uid,
    });
  }

  static async updateProviderOption(
    docId: string,
    data: Partial<ProviderOption>,
    facilityId: string = OrganizationType.NYCBS_PHARMA,
  ): Promise<void> {
    const path = FirestoreCollectionReference.pharmaProviderOptions(facilityId);
    await FirestoreService.updateDocument(path, docId, data);
  }

  static async deleteProviderOption(
    docId: string,
    facilityId: string = OrganizationType.NYCBS_PHARMA,
  ): Promise<void> {
    const path = FirestoreCollectionReference.pharmaProviderOptions(facilityId);
    await FirestoreService.deleteDocument(path, docId);
  }
}
